import { useEffect } from 'react';
import useModalStore from './useModalStore';

export const usePortalCleanerContainer = (
  container,
  isVisible: boolean,
  key: string
) => {
  const clearModalsConfigWithException = useModalStore(
    (state) => state.clearModalsConfigWithException
  );
  useEffect(() => {
    if (
      container &&
      isVisible &&
      container.hasChildNodes() &&
      container.children?.length > 1
    ) {
      clearModalsConfigWithException(key);
    }
  }, [isVisible, container?.children?.length]);

  return container;
};
